import axios, {AxiosResponse} from "axios";
import EmployeeName from "@/model/EmployeeName";

const PATH = "/accounting";

export default {
    findAvailableOrders(date: string) {
        return axios
          .get(`${PATH}/worklog/availableOrders`, {
              params: {
                  date: date
              }
          });
    },
    findEmployees(term: string): Promise<AxiosResponse<Array<EmployeeName>>> {
        return axios
          .get(`${PATH}/worklog/employees`, {
              params: {
                  term: term
              }
          });
    }
};
